import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MyQuotation } from '../../models/quotations/MyQuotation';

const StyledQuotationDetailsWrapper = styled(Box)(() => ({
    paddingBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
}));
const StyledSpan = styled('span')(() => ({
    fontWeight: 'bold',
}));

export const MyQuotationDetailsSummary: React.FC<{ quote: MyQuotation }> = (
    props
) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });
    const { quote } = props;
    const today = new Date();

    const isExpired = (): boolean => {
        return new Date(quote.quoteValidToDate) > today;
    };

    return (
        <>
            <StyledQuotationDetailsWrapper>
                <Box>
                    {t('DETAILS.LINE_NUMBER')}:{' '}
                    <StyledSpan>{quote.salesQuoteLines.length}</StyledSpan>
                </Box>
                <Box>
                    {t('DETAILS.STATUS')}:{' '}
                    <StyledSpan>
                        {quote.quoteValidToDate != '0001-01-01' && isExpired
                            ? t('STATUS.EXPIRED')
                            : t(
                                  'STATUS.' +
                                      quote.status
                                          .toString()
                                          .toUpperCase()
                                          .replace(' ', '_')
                              )}
                    </StyledSpan>
                </Box>
                <Box>
                    {t('DETAILS.CREATE_DATE')}:{' '}
                    <StyledSpan>{quote.orderDate}</StyledSpan>
                </Box>
                <Box>
                    {t('DETAILS.VALID_DATE')}:{' '}
                    <StyledSpan>
                        {quote.quoteValidToDate == '0001-01-01'
                            ? '-'
                            : quote.quoteValidToDate}
                    </StyledSpan>
                </Box>
            </StyledQuotationDetailsWrapper>
        </>
    );
};
